export const BULK_LIVE_DATE_UPDATE_USERS = [
  "mehak.kochhar@broadwaylive.in",
  "purav.acharya@broadwaylive.in",
  "anchal.jain@broadwaylive.in",
  "jagan.kumar@broadwaylive.in",
  "shravya.venkatesh@broadwaylive.in",
  "animesh.garg@broadwaylive.in",
  "shambhavi.singh@broadwaylive.in",
  "anuj.kumar@broadwaylive.in",
];
